import { Component } from '@angular/core';
import { MyProjectsIndexTable, TimeTrackingMenuService } from '@app/modules/time-tracking/services';

@Component({
    templateUrl: './my-projects-index.template.html',
})
export class MyProjectsIndexView {
    constructor(
        public table: MyProjectsIndexTable,
        public menuService: TimeTrackingMenuService
    ) {
        this.table.reload();
    }
}
